import { pgTable, uuid, text, timestamp, integer, jsonb, index, smallint, unique, } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
export var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus["PENDING"] = "pending";
    DocumentStatus["READY"] = "ready";
    DocumentStatus["FAILED"] = "failed";
})(DocumentStatus || (DocumentStatus = {}));
export var DocumentSourceType;
(function (DocumentSourceType) {
    DocumentSourceType["NOTION"] = "notion";
    DocumentSourceType["GOOGLE_DRIVE"] = "google_drive";
    DocumentSourceType["EMAIL"] = "email";
    DocumentSourceType["GITHUB"] = "github";
    DocumentSourceType["INTERNAL"] = "internal";
    DocumentSourceType["OTHER"] = "other";
    DocumentSourceType["WEBSITE"] = "website";
})(DocumentSourceType || (DocumentSourceType = {}));
export const documents = pgTable("documents", {
    id: uuid("id").primaryKey().defaultRandom(),
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    sourceType: text("source_type").notNull().$type(),
    sourceId: text("source_id"),
    title: text("title"),
    summary: text("summary"),
    contentRef: text("content_ref"), // object storage key/url
    checksumSha256: text("checksum_sha256"),
    sizeBytes: integer("size_bytes"),
    mimeType: text("mime_type"),
    tags: jsonb("tags").notNull().default({}),
    embeddingVersion: smallint("embedding_version").notNull().default(1),
    status: text("status").notNull().$type().default(DocumentStatus.PENDING),
    lastIndexedAt: timestamp("last_indexed_at", { withTimezone: true }),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true })
        .notNull()
        .defaultNow()
        .$onUpdate(() => new Date()),
}, table => ({
    companyUpdatedIdx: index("idx_documents_company_updated").on(table.companyId, table.updatedAt),
    companySourceIdx: index("idx_documents_company_source").on(table.companyId, table.sourceType, table.sourceId),
    uniqueCompanySourceChecksum: unique("unique_documents_company_source_checksum").on(table.companyId, table.sourceId, table.checksumSha256),
}));
